export class InvestigationTypeCategoryEntity {
  constructor(
    readonly id: string,
    readonly name: string,
    readonly description: string,
    readonly sortOrder: number,
    readonly isActive: boolean,
  ) {}
}
